import dayjs from '@/shared/lib/dayjs';

/**
 * Converte uma string de data UTC para um objeto Day.js no fuso horário do Brasil (America/Sao_Paulo).
 * Retorna `null` quando a entrada for nula ou indefinida.
 *
 * @param utcDate - String de data em UTC
 * @returns Objeto Day.js ajustado para America/Sao_Paulo, ou `null` se a entrada for nula/indefinida
 *
 * @example
 * ```ts
 * toBrazilTime('2024-01-15T14:00:00Z').format('DD/MM/YYYY HH:mm') // '15/01/2024 11:00'
 * toBrazilTime(null) // null
 * ```
 */
export function toBrazilTime(utcDate: string | null | undefined): dayjs.Dayjs | null {
  if (!utcDate) return null;
  return dayjs.utc(utcDate).tz('America/Sao_Paulo');
}
